import QueryTags from '../../types/QueryTags'
import { EndpointBuilder } from '@reduxjs/toolkit/dist/query/endpointDefinitions'
import { BaseQueryFn, FetchArgs, FetchBaseQueryError } from '@reduxjs/toolkit/query/react'



type  RequestType = {
  payerNames: string,
  payerAccount: string,
  payerContact: string,
  currency: string,
}

const baseUrl = '/bankingAsService/openAPI'

const openAPIEndpoints = (builder: EndpointBuilder<
  BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError>, QueryTags, 'data'>) =>
  ({
    fetchOpenApiKeys: builder.mutation<any, RequestType>({
      query: (body) => {
        return ({
          url: `${baseUrl}/payment/initiate`,
          method: 'post',
          body,
        })
      },
    }),
    fetchOpenApipendingTransactions: builder.query<any, any>({
      query: (body) => {
        return ({
          url:  `${baseUrl}/payment/getPending`,
          method: 'post',
          body,
        })
      },
    }),
    authorizePendingTransaction: builder.mutation<any, any>({
      query: ({payload, otp, userChannel, otpIdentifier }) => {
        return ({
          url:  `${baseUrl}/payment/completeWithOTP?emailOrPhoneNumber=${userChannel}&otpCode=${otp}&otpIdentifier=${otpIdentifier}`,
          method: 'put',
          body:payload,
        })
      },
    }),
  })
export default openAPIEndpoints
